export const UPDATE_CONTACTS = {
    APPEND_CONTACTS: 'append',
    REFRESH_CONTACTS: 'refresh',
    REPLACE_CONTACTS: 'replace',
    NO_ACTION: 'nothing',
}